<template>
  <div class="authority-manage rhBrand-box position-header">
    <navHeader :titleList="['收藏行为客户']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <p class="visit-tips">
            收藏行为客户：主动收藏贵公司产品或者企业详情页的用户将被记录
          </p>
          <el-table :data="tableData" border style="width: 100%" class="flex-1" stripe height="100%">
            <el-table-column
              type="index"
              width="60px"
              align="center"
              label="序号"
            >
            </el-table-column>
            <el-table-column
              prop="sourceType"
              align="center"
              show-overflow-tooltip
              label="收藏类型"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              align="center"
              show-overflow-tooltip
              label="收藏名称"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              align="center"
              show-overflow-tooltip
              label="收藏时间"
            >
            </el-table-column>
            <el-table-column align="center" width="100" label="操作" fixed="right">
              <template v-slot="scope">
                <el-button icon="el-icon-document-checked" type="text" @click="goDetail(scope.row.id)"
                           size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'

export default {
  data () {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 1
    }
  },
  components: {
    navHeader
  },
  created () {
    this.getPageList()
  },
  mounted () {},
  methods: {
    async getPageList () {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      let { data: res } = await this.$http.post(
        '/myCollect/getPageList',
        params
      )
      console.log(res)
      if (res.code === '200') {
        this.tableData = res.data.records
        this.tableData.forEach((item) => {
          item.mobile = item.sysUser ? item.sysUser.mobile : ''
          item.nickName = item.sysUser ? item.sysUser.nickName : ''
        })
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    goDetail (id) {
      this.$router.push({
        name: 'VisitInfoDetail',
        query: { id }
      })
    }
  }
}
</script>

<style lang="less">
.visit-tips {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/pages/visitInfo/index.vue